/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupforfree3Inputs */

const en_signupforfree3 = /** @type {(inputs: Signupforfree3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up for free`)
};

const de_signupforfree3 = /** @type {(inputs: Signupforfree3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos anmelden`)
};

/**
* | output |
* | --- |
* | "Sign up for free" |
*
* @param {Signupforfree3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupforfree3 = /** @type {((inputs?: Signupforfree3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupforfree3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupforfree3(inputs)
	return de_signupforfree3(inputs)
});
export { signupforfree3 as "signUpForFree" }